export default {
  // Words
  appName: 'Faramet',
  appTagline: 'Courier Panel'
}
